import "./Locations.css";
import himachal from "../media/himachalbg.jpg";
import dubai from "../media/dubai.jpg";
import europe from "../media/europebg.jpg";
import kerala from "../media/keralabg.jpg";
import maldives from "../media/himachalbg.jpg";
import rajasthan from "../media/rajasthan.jpg";
import thailand from "../media/thailandbg.jpg";
import goa from "../media/goa.jpg";
import { PackageCard } from "../components/PackageCard";
import { Searchbox } from "../components/Searchbox";
import { useState, useEffect } from "react";
import mukafall from "../media/tourism/Mukha fall/fall1.jpeg";

import fossils from "../media/tourism/Fossils Park/fossils1.jpeg";
import rock from "../media/tourism/Canvas Rock Painting/rock1.jpg";
import Shiva from "../media/tourism/Shiv Dwar/shiv1.jpg";
import vijayfort from "../media/tourism/Vijaygarh Fort/fort2.jpg";
import dam from "../media/tourism/Rihand Dam/dam3.jpeg";
import abadi from "../media/tourism/Abadi Picnic Spot/abadi2.jpg";
import Agori from "../media/tourism/Agori Fort/fort1.jpg";
import Khanta from "../media/tourism/other/Khanta Picnic Spot/test1.jpg";
import dari from "../media/tourism/other/Lakhaniya Dari/test1.jpg";
import naugarhfall from "../media/tourism/other/Naugarh Fall/fall.jpg";
import dhanraul from "../media/tourism/other/Dhandharoul Dam/dam2.jpg";
import mangleshwar from "../media/tourism/other/Mangleshwar MAHADEV/mahadev7.jpg";
import mandir from "../media/tourism/Renukeshwar Mandir/mandir.jpg";
import bio from "../media/tourism/Biodiversity Park/park22.jpg";
import obradam from "../media/tourism/Obra Dam/dam1.jpeg";
import kaimur from "../media/tourism/other/Kaimoor Wildlife Sanctuary/1.jpg";
import soneco from "../media/tourism/Son Eco point/1.jpg";
import nagwa from "../media/tourism/other/Nagwa Dam and Silhat Dam/1.jpg"
import rajdari from "../media/tourism/other/Rajdari Devdari/1.jpg";
import dongia from "../media/tourism/other/Dongia Picnic SPot/1.jpg";
import varanasi from "../media/tourism/other/Varanasi/107570888.jpg";
import prayag from "../media/tourism/other/Allahabad/430878150_721838313437533_8365993422936757979_n.jpg";
import mundeshwari from "../media/tourism/other/Maa Mundeshwari/cq5dam.web_.2000.765-3_REF-1.jpg";
import vindhyachal from "../media/tourism/other/Vindhyachal/444481078_775854848026942_3025085871748325057_n.jpg";


export const Locations = () => {
           
  const packageInfoRow1 = [
    
      
      {
        place: "Varanasi - Kashi",
        info: "Discover the Timeless Beauty of Varanasi: The Spiritual Heart of India",
        img: varanasi,
        price: "4000-5000 INR",
        placename: "varanasi-kashi",
      },
      {
        place: "Allahabad - Prayagraj - Kumbh City",
        info: "The Sangam City, India’s Freedom history and much more",
        img: prayag,
        price: "4000-5000 INR",
        placename: "allahabad-prayagraj",
      },
      {
        place: "Vindhyachal Temple Mirzapur",
        info: "A Divine Pilgrimage to the Abode of Goddess Vindhyavasini at Mirzapur",
        img: vindhyachal,
        price: "4000-5000 INR",
        placename: "vindhyachal",
      },
      {
        place: "Mukha Fall",
        info: "Scenic beauty of river belan falling from a height of 100 ft",
        img: mukafall,
        price: "4000-5000 INR",
        placename: "mukhafall",
      },

      {
        place: "Rihand Dam",
        info: "Largest dam of India by volume",
        img: dam,
        price: "4000-5000 INR",
        placename: "rihanddam",
      },
      {
        place: "Fossils Park",
        info: "Asia's oldest and Over 150 Crore year old fossils park",
        img: fossils,
        price: "4000-5000 INR",
        placename: "fossilspark",
      },
      {
        place: "ShivDwar Temple",
        info: "11th Century Temple of Lord Shiva and Goddess Parvati",
        img: Shiva,
        price: "4000-5000 INR",
        placename: "shivdwartemple",
      },
      {
        place: "Vijaygarh Fort",
        info: "Built at time of Mahabharata and also famous for Chandrakanta",
        img: vijayfort,
        price: "4000-5000 INR",
        placename: "vijaygarhfort",
      },
     
      {
        place: "Aabadi Picnic Spot",
        info: "Known as Mini Goa of Sonbhadra: Lush green forests meet serene valleys and river",
        img: abadi,
        price: "4000-5000 INR",
        placename: "abadipicnic",
      },
      {
        place: "Agori Fort",
        info: "A historic marvel by the Son River, where warriors of sonbhadra and hidden treasures come alive",
        img: Agori,
        price: "4000-5000 INR",
        placename: "agorifort",
      },
      {
        place: "Khanta Picnic Spot",
        info: "A serene retreat in Myorpur, Sonbhadra, perfect for nature lovers and family outings",
        img: Khanta,
        price: "4000-5000 INR",
        placename: "khanta",
      },
      {
        place: "Lakhaniya Dari",
        info: "A majestic 150m waterfall near Varanasi, offering scenic beauty and thrilling adventures for nature lovers",
        img: dari,
        price: "4000-5000 INR",
        placename: "lakhaniyadari",
      },
      {
        place: "Naugarh Waterfall",
        info: "A serene cascade nestled in the lush greenery of Chandauli, perfect for nature enthusiasts and picnickers",
        img: naugarhfall,
        price: "4000-5000 INR",
        placename: "naugarhwaterfall",
      },
      {
        place: "Dhandhraul Dam",
        info: "A serene reservoir on the Ghaghar River, offering picturesque views and vital water resources in Sonbhadra",
        img: dhanraul,
        price: "4000-5000 INR",
        placename: "dhandhrauldam",
      },
      {
        place: "Mangleshwar Mahadev Temple",
        info: "A serene hilltop shrine in Sonbhadra, offering divine blessings and breathtaking views",
        img: mangleshwar,
        price: "4000-5000 INR",
        placename: "mangleshwarmahadev",
      },
      {
        place: "Shri Renukeshwar Mahadev Mandir",
        info: "A splendid temple in Renukoot, with one of the largest Nandi idol in India",
        img: mandir,
        price: "4000-5000 INR",
        placename: "renukeshwar",
      },
      {
        place: "Hathinala Biodiversity Park",
        info: "A lush haven in Sonbhadra teeming with vibrant wildlife and breathtaking greenery",
        img: bio,
        price: "4000-5000 INR",
        placename: "hathinalabiodiversity",
      },
      {
        place: "Obra Dam",
        info: "A marvel of engineering in Sonbhadra, offering scenic beauty and hydropower brilliance",
        img: obradam,
        price: "4000-5000 INR",
        placename: "obradam",
      },
      {
        place: "Kaimoor Wildlife Sanctuary",
        info: "Uttar Pradesh's largest sanctuary, a haven of biodiversity nestled in the scenic Kaimur Hills",
        img: kaimur,
        price: "4000-5000 INR",
        placename: "kaimoor-wildlife-sanctuary",
      },
      {
        place: "Maa Mundeshwari Temple",
        info: "India’s Oldest Functional Temple and a Sacred Pilgrimage Destination",
        img: mundeshwari,
        price: "4000-5000 INR",
        placename: "mundeshwari",
      },
      {
        place: "Son Eco Point and Veer Lorik Stone",
        info: "Breathtaking Son Valley meets the legendary Veer Lorik Stone history, a symbol of Love and bravery",
        img: soneco,
        price: "4000-5000 INR",
        placename: "son-ecopoint",
      },
      {
        place: "Rajdari and Devdari Waterfalls",
        info: "Waterfalls, surrounded by rugged cliffs, lush greenery, and serene valleys, with gravity magic",
        img: rajdari,
        price: "4000-5000 INR",
        placename: "devdari-rajdari-waterfall",
      },
      {
        place: "Nagwa and Silhat Dams",
        info: "An early engineering marvel built since 1918,the best Picnic Spot, also known as Mini Ooty",
        img: nagwa,
        price: "4000-5000 INR",
        placename: "nagwadam-silhat-dam",
      },
      {
        place: "Dongia Picnic Spot",
        info: "Near Rihand Dam, a serene ecotourism retreat in Sonbhadra, offering boating and lush greenery",
        img: dongia,
        price: "4000-5000 INR",
        placename: "dongia-picnic-spot",
      },
      {
        place: "Cave Paintings",
        info: "Over 4000 years old Rock paintings, showing culture",
        img: rock,
        price: "4000-5000 INR",
        placename: "cavepaintings",
      },


  ];

  const [searchField, setSearchField] = useState("");
  const [places, setPlaces] = useState(packageInfoRow1);
  const [filteredPlaces, setFilteredPlaces] = useState(places);

  useEffect(() => {
    const newfilteredPlaces = places.filter((place) => {
      return place.place.toLocaleLowerCase().includes(searchField);
    });

    setFilteredPlaces(newfilteredPlaces);
  }, [places, searchField]);

  const handleOnChange = (e) => {
    const search = e.target.value.toLocaleLowerCase();
    setSearchField(search);
  };
  return (
    <>
      <section className="packages">
        <div className="package-container">
          <h2>
            All Locations
            <hr />
          </h2>
          <p>
          Below is list of all Places of Interest where you can visit in Sonbhadra as per our tourism package, we offer our services for all the mentioned locations. Embark on an unforgettable adventure of sonbhadra, India's hidden gem, by Sonbhadra tourism.
          Explore ancient temples, cascading waterfalls, breathtaking wildlife sanctuaries, and rich tribal culture. 
          Discover the perfect blend of history, adventure, science and natural beauty.
          </p>
          <Searchbox handleOnChange={handleOnChange} />

          <div className="p-row">
            {filteredPlaces.map((element) => {
              return (
                <PackageCard
                  placeName={element.place}
                  img={element.img}
                  info={element.info}
                  // price={element.price}
                  location={element.place}
                  locationname={element.placename}
                />
              );
            })}
          </div>
        </div>
      </section>
    </>
  );
};
